import type { ReactNode } from 'react';
import { IconX } from '@tabler/icons-react';
import { Box, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  Tooltip,
  Typography,
} from '@forethought-technologies/forethought-elements';
import { PopupModal } from 'components/PopupModal';
import { MODAL_BORDER_RADIUS } from 'embed/constants';

export default function GenericPopupModal({
  content,
  footer,
  isLoading = false,
  isOpen,
  onClose,
  position = 'bottom',
  title,
}: {
  content: string;
  footer: ReactNode;
  isLoading?: boolean;
  isOpen: boolean;
  onClose: () => void;
  position?: 'top' | 'bottom';
  title: string;
}): JSX.Element {
  const theme = useTheme();

  if (!isOpen) {
    return <></>;
  }

  return (
    <PopupModal onClickAway={onClose} open={isOpen} position={position}>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          gap: '24px',
        }}
      >
        <Box display='flex' justifyContent='space-between' width='100%'>
          <Typography variant='font16Bold'>{title}</Typography>
          <Tooltip tooltipContent={`Close ${title}`}>
            <Box
              aria-label={`Close ${title}`}
              component='button'
              onClick={onClose}
              sx={{
                backgroundColor: 'transparent',
                border: 'none',
                color: theme.palette.colors.grey[800],
                cursor: 'pointer',
                height: '20px',
                padding: 0,
              }}
              type='button'
            >
              <IconX size={20} />
            </Box>
          </Tooltip>
        </Box>
        <Box padding='8px 0' width='100%'>
          <Typography variant='font14'>{content}</Typography>
        </Box>
        {footer}
        {isLoading && (
          <Box
            alignItems='center'
            bgcolor='rgba(0, 0, 0, 0.1)'
            borderRadius={MODAL_BORDER_RADIUS}
            display='flex'
            height='100%'
            justifyContent='center'
            position='absolute'
            top={0}
            width='100%'
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </PopupModal>
  );
}
